export interface DataIn {
    armed: null | boolean,
    alarm: null | boolean,
    entryDelay: null | boolean,
    exitDelay: null | boolean,
    armWarning: null | boolean,
    deferDisarmed: null | boolean,
    detectingActiveInputs: null | boolean,
    walkTestActive: null | boolean,
    awayArm: null | boolean,
    stayArm: null | boolean,
    sleepArm: null | boolean,
    disarmed: null | boolean,
    armReady: null | boolean,
    //
    error: boolean,
    connencting: boolean,
  };

export interface DataOut { 
    areaControlType: 'Arm'|'Disarm'|'ArmStay'|'ArmSleep',
    areaControlData?: { ExitDelay?: boolean, SealCheck?: boolean },
}
